import React__default from 'react';
import { Icon } from '../Icon/Icon.es.js';

const tableHeadSortButton = "_table-head-sort-button_1xs64_1";
const styles = {
	tableHeadSortButton: tableHeadSortButton
};

const TableHeadSortButton = (props) => {
  return React__default.createElement(
    "button",
    { type: "button", className: styles.tableHeadSortButton, onClick: props.onClick, "data-zds": true },
    props.children,
    React__default.createElement(Icon, { color: "GrayWarm6", name: "arrowDropdown", size: 16 })
  );
};

export { TableHeadSortButton };
//# sourceMappingURL=TableHeadSortButton.es.js.map
